// src/utils/iconLoader.ts
export const _loadIcon = async (symbol: string) => {
    try {
        const icon = await import(`assets/coins/${symbol}.svg`);
        return icon.default; // Assuming the SVG is exported as default
    } catch (error) {
        const icon = await import(`assets/coins/default.svg`);
        return icon.default;
    }
};
